// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPhone,
//   faEnvelope,
//   faGlobe,
//   faUser,
//   faPaperPlane,
//   faComment,
// } from "@fortawesome/free-solid-svg-icons";

// const ContactForm = () => {
//   return (
//     <div className="flex flex-col items-center w-full mx-auto text-black rounded-xl p-5 mt-5">
//       <div className="w-full max-w-3xl p-4 rounded-md justify-center">
//         <h2 className="text-3xl font-bold text-center mb-4 flex items-center justify-center text-[#1F4644]">
//           <FontAwesomeIcon icon={faPaperPlane} className="mr-2 ml-2 h-10 w-10 text-[#1F4644]" />
//         </h2>

//         <form
//           action="https://formspree.io/f/xdkeynvb"
//           method="POST"
//           className="space-y-4"
//         >
//           <div className="space-y-2">
//             <label htmlFor="name" className="block text-sm font-medium"></label>
//             <div className="flex items-center border border-gray-300 rounded-md">
//               <FontAwesomeIcon icon={faUser} className="ml-2 h-5 w-5 text-[#1F4644]" />
//               <input
//                 id="name"
//                 type="text"
//                 name="name"
//                 required
//                 placeholder="Enter your name"
//                 className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
//               />
//             </div>
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="phone" className="block text-sm font-medium"></label>
//             <div className="flex items-center border border-gray-300 rounded-md">
//               <FontAwesomeIcon icon={faPhone} className="ml-2 h-5 w-5 text-[#1F4644]" />
//               <input
//                 id="phone"
//                 type="tel"
//                 name="phone"
//                 required
//                 placeholder="Enter your phone number"
//                 className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
//               />
//             </div>
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="email" className="block text-sm font-medium"></label>
//             <div className="flex items-center border border-gray-300 rounded-md">
//               <FontAwesomeIcon icon={faEnvelope} className="ml-2 h-5 w-5 text-[#1F4644]" />
//               <input
//                 id="email"
//                 type="email"
//                 name="email"
//                 required
//                 placeholder="Enter your email"
//                 className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
//               />
//             </div>
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="destination" className="block text-sm font-medium"></label>
//             <div className="flex items-center border border-gray-300 rounded-md">
//               <FontAwesomeIcon icon={faGlobe} className="ml-2 h-5 w-5 text-[#1F4644]" />
//               <select
//                 id="destination"
//                 name="destination"
//                 required
//                 className="w-full p-2 bg-transparent text-black  focus:ring-2 "
//               >
//                 <option value="" disabled selected>
//                   Select your destination
//                 </option>
//                 <option value="Europe">Vietnam</option>
//                 <option value="Asia">Bali</option>
//                 <option value="Americas">Dubai</option>
//                 <option value="Africa">Baku</option>
//                 <option value="Oceania">Almaty</option>
//                 <option value="Oceania">manali</option>
//                 <option value="Oceania">solang valley</option>
//                 <option value="Oceania">spiti</option>
//                 <option value="Oceania">other</option>
//               </select>
//             </div>
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-[#1F4644] text-white font-semibold py-2 rounded-md transition duration-300 flex items-center justify-center"
//           >
//             <FontAwesomeIcon icon={faPaperPlane} className="mr-2 h-4 w-4" />
//             Get Quote
//           </button>
//         </form>

//         <div className="mt-4 flex space-x-2">
//           <button className="flex-1 bg-[#1F4644] text-white py-2 rounded-md transition duration-300 flex items-center justify-center">
//             <FontAwesomeIcon icon={faPhone} className="mr-2 h-4 w-4" /> Call Now
//           </button>
//           <button className="flex-1 bg-[#1F4644] text-white py-2 rounded-md transition duration-300 flex items-center justify-center">
//             <FontAwesomeIcon icon={faComment} className="mr-2 h-4 w-4" /> WhatsApp
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;


import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faGlobe,
  faUser,
  faPaperPlane,
  faComment,
} from "@fortawesome/free-solid-svg-icons";

const ContactForm = () => {
  return (
    <div className="flex flex-col items-center w-full mx-auto text-black rounded-xl p-5 mt-5">
      <div className="w-full max-w-3xl p-4 rounded-md justify-center">
        <h2 className="text-3xl font-bold text-center mb-4 flex items-center justify-center text-[#1F4644]">
          <FontAwesomeIcon icon={faPaperPlane} className="mr-2 ml-2 h-10 w-10 text-[#1F4644]" />
        </h2>

        <form
          action="https://formspree.io/f/xdkeynvb"
          method="POST"
          className="space-y-4"
        >
          <div className="space-y-2">
            <label htmlFor="name" className="block text-sm font-medium"></label>
            <div className="flex items-center border border-gray-300 rounded-md">
              <FontAwesomeIcon icon={faUser} className="ml-2 h-5 w-5 text-[#1F4644]" />
              <input
                id="name"
                type="text"
                name="name"
                required
                placeholder="Enter your name"
                className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="phone" className="block text-sm font-medium"></label>
            <div className="flex items-center border border-gray-300 rounded-md">
              <FontAwesomeIcon icon={faPhone} className="ml-2 h-5 w-5 text-[#1F4644]" />
              <input
                id="phone"
                type="tel"
                name="phone"
                required
                placeholder="Enter your phone number"
                className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-medium"></label>
            <div className="flex items-center border border-gray-300 rounded-md">
              <FontAwesomeIcon icon={faEnvelope} className="ml-2 h-5 w-5 text-[#1F4644]" />
              <input
                id="email"
                type="email"
                name="email"
                required
                placeholder="Enter your email"
                className="w-full p-2 bg-transparent text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1F4644]"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="destination" className="block text-sm font-medium"></label>
            <div className="flex items-center border border-gray-300 rounded-md">
              <FontAwesomeIcon icon={faGlobe} className="ml-2 h-5 w-5 text-[#1F4644]" />
              <select
                id="destination"
                name="destination"
                required
                className="w-full p-2 bg-transparent text-black  focus:ring-2 "
              >
                <option value="" disabled selected>
                  Select your destination
                </option>
                <option value="Vietnam">Vietnam</option>
                <option value="Bali">Bali</option>
                <option value="Dubai">Dubai</option>
                <option value="Baku">Baku</option>
                <option value="Almaty">Almaty</option>
                <option value="Manali">Manali</option>
                <option value="Solang Valley">Solang Valley</option>
                <option value="Spiti">Spiti</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-[#1F4644] text-white font-semibold py-2 rounded-md transition duration-300 flex items-center justify-center"
          >
            <FontAwesomeIcon icon={faPaperPlane} className="mr-2 h-4 w-4" />
            Get Quote
          </button>
        </form>

        <div className="mt-4 flex space-x-2">
          <a
            href="tel:+918287373076"
            className="flex-1 bg-[#1F4644] text-white py-2 rounded-md transition duration-300 flex items-center justify-center"
          >
            <FontAwesomeIcon icon={faPhone} className="mr-2 h-4 w-4" /> Call Now
          </a>
          <a
            href="https://wa.me/918287373076"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-[#1F4644] text-white py-2 rounded-md transition duration-300 flex items-center justify-center"
          >
            <FontAwesomeIcon icon={faComment} className="mr-2 h-4 w-4" /> WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
